<template>
  <div>
    <header-top-dashboard primary>
      <v-row class="mt-0">
        <v-col
            v-for="(item, i) in miniCards"
            :key="i"
            cols="12"
            lg="4"
            md="9"
            class="py-0"
        >
          <v-card class="card-shadow mb-6">
            <v-card-text class="card-stats-padding">
              <v-row no-gutters>
                <v-col>
                  <div
                      class="font-weight-600 text-muted text-uppercase text-h5"
                  >
                    {{ item.subtitle }}
                  </div>
                  <p class="font-weight-600 text-h2 text-typo mb-0">
                    {{ item.title }}
                  </p>
                </v-col>
                <v-col class="text-right">
                  <v-avatar :color="item.gradient">
                    <v-icon size="20" class="text-white">
                      {{ item.icon }}
                    </v-icon>
                  </v-avatar>
                </v-col>
              </v-row>

              <p class="mt-4 mb-0 text-body font-weight-light">
                <span class="text-success me-2"> {{ item.increase }}%</span>Since last month
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </header-top-dashboard>
    <v-container fluid class="pt-0 px-6 mt-n13">
      <Overlay :loading="loading" />
      <v-row class="mt-0">
        <v-col lg="4" class="pt-6">
          <notification-list></notification-list>
        </v-col>
        <v-col lg="8" class="pt-6">
          <v-card class="card-shadow">
            <div class="card-header-padding card-border-bottom">
              <p class="font-weight-600 text-typo text-h4 mb-0">採用数の推移</p>
            </div>
            <v-card-text class="card-padding">
              <div class="chart-area">
                <canvas :height="350" :id="salesChartID"></canvas>
              </div>
            </v-card-text>
          </v-card>

        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

import axios from "axios";
import { mapActions } from "vuex";
import { salesChart } from "@/components/Charts/Chart";
import HeaderTopDashboard from "../../components/HeaderTopDashboard";
import NotificationList from "../Widgets/NotificationList";
import Overlay from '../../components/Overlay.vue';

export default {
  name: "Dashboard",
  components: {
    HeaderTopDashboard,
    NotificationList,
    Overlay
  },
  data() {
    return {
      salesChartID: "salesChart",
      miniCards: [
        {
          subtitle: "採用数",
          title: "",
          increase: "",
          gradient: "bg-gradient-danger",
          icon: "ni-active-40",
        },
        {
          subtitle: "応募数",
          title: "",
          increase: "",
          gradient: "bg-gradient-warning",
          icon: "ni-chart-pie-35",
        },
        {
          subtitle: "流入数",
          title: "",
          increase: "",
          gradient: "bg-gradient-success",
          icon: "ni-chart-bar-32",
        },
      ],
      loading: false
    }
  },
  methods: {
    ...mapActions("snackbar", ["openSnackbarApiError", "openSnackbarValidationError"]),
  },

  async mounted() {
    salesChart.createChart(this.salesChartID);

    if (this.$route.params.companyId) {
      this.loading = true;
      try {
        const res = await axios.get(
          "/dashboard/candidates?companyId=" + this.$route.params.companyId
        );
        this.miniCards[0].title = res.data.RecruitCount;
        this.miniCards[0].increase = res.data.RecruitCountPercent;
        this.miniCards[1].title = res.data.ApplicationCount;
        this.miniCards[1].increase = res.data.ApplicationCountPercent;
        this.miniCards[2].title = res.data.EntryCount;
        this.miniCards[2].increase = res.data.EntryCountPercent;
      } catch (e) {
         const res = e.response;
        if (res.status === 400) {
          this.openSnackbarValidationError(res.data)
        } else {
          this.openSnackbarApiError();
        }
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>

</style>